import React, { useEffect, useState } from "react";
import ImageIcons from '../imageComponent/ImageIcons';
import Slider from "react-slick";
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazy-load';
import { IoCheckmarkDoneSharp, IoClose } from "react-icons/io5";
const Hero = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => document.body.classList.remove('overflow-hidden');
  }, [isOpen]);

  const handleOverlayClick = (e) => {
    if (e.target.id === 'modalOverlay') {
      setIsOpen(false);
    }
  };

  let settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1000,
    adaptiveHeight: true,
  };
  return (
    <section className="banner bg-[#FBFBFD] lg:overflow-hidden 2xl:pt-[25px] md:pt-[15px] pt-[25px] pb-0 max-md:mb-[15px]">
      <div className='container'>
        {isOpen && (
          <div id="modalOverlay"
          onClick={handleOverlayClick} className="modal fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.90)] z-[99999] overflow-y-auto flex items-center justify-center">
                <span className="cursor-pointer bg-[#fff] hover:bg-[#f48533] absolute sm:top-[20px] top-0 sm:right-[20px] right-0 z-10 text-[#000] hover:text-white duration-500 sm:w-[45px] w-[40px] sm:h-[45px] h-[40px] flex items-center justify-center" onClick={() => setIsOpen(false)}>
                  <IoClose className='text-[25px]' />
                </span>
            <div className="relative overflow-y-hidden bg-[white] rounded-lg sm:my-[40px] my-[30px] md:mx-auto mx-[20px] lg:max-w-[770px] max-w-[750px]">
              <div className='text-center sm:px-[30px] px-[20px] py-[18px] bg-[#f48533] text-white'>
                <h4 className='mb-0'>Refer a Friend for a myInternet Connection</h4>
              </div>

              <div className='sm:px-[30px] px-[20px] sm:py-[30px] py-[20px]'>

              <div className="flex justify-center items-center gap-[10px] mx-auto mb-[20px] max-w-[320px]">
                <Link to="https://play.google.com/store/apps/details?id=app.customerportal.digitax" target="_blank"
                  class="flex items-center justify-center w-full px-[15px] py-[7px] text-center text-white bg-[#f3f3f3] hover:bg-[#fff0e4] rounded-2xl"
                  rel="noreferrer">
                  <svg class="w-7" viewBox="-9 0 274 274" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g>
                          <path
                              d="M188.81319,178.874645 C221.272218,161.051727 245.880297,147.470853 248.001319,146.415618 C254.78648,142.806714 261.79324,133.256838 248.001319,125.838536 C243.548228,123.506467 219.573289,110.347687 188.81319,93.3795092 L146.171146,136.443648 L188.81319,178.874645 Z"
                              fill="#FFD900"></path>
                          <path
                              d="M146.171146,136.443648 L10.3940643,273.286517 C13.5808739,273.708611 17.1792251,272.864423 21.4212696,270.532353 C30.3274526,265.657168 124.739324,214.098388 188.81319,178.885198 L146.171146,136.443648 Z"
                              fill="#F43249"></path>
                          <path
                              d="M146.171146,136.443648 L188.81319,93.5905562 C188.81319,93.5905562 30.9711459,7.45172685 21.4212696,2.36549437 C17.8229184,0.233919759 13.7919209,-0.399221214 10.1830173,0.233919759 L146.171146,136.443648 Z"
                              fill="#00EE76"></path>
                          <path
                              d="M146.171146,136.443648 L10.1830173,0.233919759 C4.6641385,1.51075405 0,6.38593954 0,16.3579099 C0,32.270853 0,244.003747 0,257.162527 C0,266.290309 3.60890354,272.864423 10.3940643,273.497564 L146.171146,136.443648 Z"
                              fill="#00D3FF"></path>
                      </g>
                  </svg>
                  <div class="flex flex-col ml-2 leading-4 text-left md:ml-3">
                      <span class="text-sm text-black">Get it on</span>
                      <span class="text-base font-semibold text-black">
                      Play Store
                  </span>
                  </div>
              </Link>
              <Link to="https://apps.apple.com/in/app/myinternet/id6475763755" target="_blank"
                  class="flex items-center justify-center w-full px-[15px] py-[7px] text-center text-white bg-[#f3f3f3] hover:bg-[#fff0e4] rounded-2xl"
                  rel="noreferrer">
                  <svg class="w-7" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0)">
                          <path
                              d="M32.6226 23.7016C32.6026 20.0267 34.2591 17.253 37.6118 15.2103C35.7359 12.5167 32.902 11.0347 29.1601 10.7443C25.6177 10.464 21.7461 12.8171 20.3292 12.8171C18.8324 12.8171 15.3998 10.8445 12.7057 10.8445C7.13769 10.9346 1.22048 15.3004 1.22048 24.1822C1.22048 26.8057 1.69945 29.516 2.65738 32.3131C3.93461 35.988 8.54465 45 13.3542 44.8498C15.8688 44.7897 17.645 43.0574 20.9179 43.0574C24.091 43.0574 25.7375 44.8498 28.5414 44.8498C33.3909 44.7797 37.5619 36.5888 38.7793 32.9039C32.2733 29.8298 32.6226 23.8919 32.6226 23.7016ZM26.9748 7.25968C29.6989 4.01535 29.4494 1.06142 29.3696 0C26.9648 0.140187 24.1808 1.64219 22.5943 3.49466C20.848 5.4773 19.8203 7.93058 20.0398 10.6943C22.6442 10.8945 25.019 9.55274 26.9748 7.25968Z"
                              fill="black"></path>
                      </g>
                      <defs>
                          <clipPath id="clip0">
                              <rect width="40" height="45" fill="white"></rect>
                          </clipPath>
                      </defs>
                  </svg>
                  <div class="flex flex-col ml-2 leading-4 text-left md:ml-3">
                      <span class="text-sm text-black">Get it on</span>
                      <span class="text-base font-semibold text-black">
                      App Store
                  </span>
                  </div>
              </Link>
              </div>

              <ul className="text-left">
                <li className='mb-[6px] relative pl-[25px]'>
                  <IoCheckmarkDoneSharp className='text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]' />
                  Open the myInternet app on your mobile and go to the "Refer a
                  Friend" section.
                </li>
                <li className='mb-[6px] relative pl-[25px]'>
                  <IoCheckmarkDoneSharp className='text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]' />
                  Enter your friend's details, including Name, Mobile Number,
                  Email Address, and City.
                </li>
                <li className='mb-[6px] relative pl-[25px]'>
                  <IoCheckmarkDoneSharp className='text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]' />
                  After successful submission, myInternet will begin the process
                  of network feasibility check, documentation, and installation.
                </li>
                <li className='relative pl-[25px]'>
                  <IoCheckmarkDoneSharp className='text-[17px] inline-block text-[#f48533] absolute left-0 top-[5px]' />
                  Once the broadband connection is successfully installed at your
                  referred address, both you and your friend will receive a 100%
                  bill discount for one month as per the chosen plan.
                </li>
              </ul>

              </div>
            </div>
          </div>
        )}

        <Slider {...settings}>
          {sliderData?.map((item, i) => (
            <div key={i} className='relative'>
              <Link to={item?.handle}>
              <div className='flex lg:flex-nowrap flex-wrap sm:gap-[30px] gap-[25px] justify-center items-center'>
                <div className='2xl:w-[55%] lg:w-[58%] w-[100%] lg:text-left text-center lg:pb-[20px]'>
                {item.referYourFriend !== 'referYourFriend' ? (
                  <LazyLoad>
                    <img className="max-lg:m-auto 2xl:!mb-[13px] !mb-[5px] 2xl:w-[420px] xl:w-[350px] md:w-[320px] sm:w-[300px] w-[270px]"
                      src={item.entertainmentIcon} alt={item.entertainmentAlt}
                    />
                  </LazyLoad>
                ) : ( '' )}
                  <h2 className="mb-[8px] font-semibold 2xl:text-[48px] xl:text-[38px] lg:text-[35px] md:text-[32px] sm:text-[30px] text-[25px]">{item.title}</h2>
                  <h2
                  className={`mb-[10px] text-[#F68140] 2xl:text-[40px] lg:text-[29px] md:text-[28px] sm:text-[26px] text-[22px]`}
                >
                  {item.subTitle}
                </h2>
                  <p className='2xl:mb-[30px] mb-[20px]'>{item.text}</p>

                  {item.referYourFriend === 'referYourFriend' ? (
                  <div className="-mt-[10px]">
                    <h5 className='mb-[15px]'>
                    Click the button below for referral
                    </h5>
                     <span
                      onClick={() => setIsOpen(true)}
                      className="cursor-pointer px-[25px] py-[12px] text-[17px] inline-block bg-black hover:bg-[#f68140] duration-500 text-white rounded-[10px] font-medium"
                    >
                      Click Here
                    </span>
                  </div>
                 ) : ( '' )}

                {item.referYourFriend !== 'referYourFriend' ? (
                  <div>
                    <ul className="md:rounded-[16px] rounded-[10px] overflow-hidden inline-flex lg:gap-[3px] sm:gap-[2px] gap-[1px]">
                      {item.subscription?.map((item) => (
                        <li className="bg-[#F68140] inline-block 2xl:py-[14px] py-[10px] xl:px-[25px] sm:px-[20px] px-[10px] text-white 2xl:text-[17px] xl:text-[16px] sm:text-[15px] text-[14px] font-medium 2xl:w-[190px] xl:w-[170px] sm:w-[135px] w-full max-sm:max-w-[112px] 2xl:pr-[55px] xl:pr-[52px] min-w-[85px] leading-[22px]">
                          <LazyLoad className="flex justify-center items-center mb-[5px] p-[5px] rounded-full overflow-hidden bg-[#fff] w-[46.5px] h-[46.5px] max-lg:mx-auto">
                            <img src={item.icon} alt={item.iconAlt} height='' width='' />
                          </LazyLoad>{item.title}</li>
                      ))}
                    </ul>
                  </div>
                  ) : ( '' )}
                </div>
                
                <LazyLoad className='relative 2xl:w-[45%] lg:w-[48%] w-[100%] 2xl:h-[560px] lg:h-[460px] sm:h-[400px] h-[280px]'>
                <img 
                  className="relative z-10 m-auto 2xl:h-[560px] lg:h-[460px] sm:h-[400px] h-[280px]" 
                  src={item.heroImg} 
                  alt={item.heroAlt} 
                  height=''
                  width=''
                />
                </LazyLoad>
              </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  )
}
const sliderData = [
  {
    referYourFriend: "referYourFriend",
    title: "Refer Your Friend",
    subTitle: "Refer your family or friends for a myInternet broadband connection and get a 100% discount on your bill.",
    text: "If the referred connection is installed and activated at the given address, both you and your friend will receive a 100% bill discount on one bill.",
    heroImg: ImageIcons.referYourFriend,
    heroAlt: "Refer Your Friend",
  },
  {
    entertainmentIcon: ImageIcons.intertainment,
    entertainmentAlt: "Intertainment",
    title: "Enhance Your internet With our bundled services",
    subTitle: "Wi-Fi + OTT +  IPTV Get 50 Mbps for just ₹399 *",
    text: "upgrade your home internet with our ultimate home internet solutions, where you will get 50 Mbps of speed at just ₹ 399. Enjoy Wi-Fi connectivity, access to OTT platforms and diverse IPTV channels- all in one package.",
    subscription: [
      {
        icon: ImageIcons.freeIptvSubscriptionHeroIcon,
        title: "Free IPTV Subscription",
        iconAlt: "Free IPTV Subscription"
      },
      {
        icon: ImageIcons.unlimitedDataHeroIcon,
        title: "Unlimited Data",
        iconAlt: "Unlimited Data"
      },
      {
        icon: ImageIcons.freeInstallationHeroIcon,
        title: "Free Installation",
        iconAlt: "Free Installation"
      },
    ],
    heroImg: ImageIcons.enhanceInternetBanner,
    heroAlt: "Enhance Your internet",
    handle: '/pricing/home-internet',
  },
  {
    entertainmentIcon: ImageIcons.entertainment,
    entertainmentAlt: "Enter Tainment",
    title: "Business internet with cloud, hosting, and domain solutions",
    subTitle: "Get 40 Mbps speed for just ₹ 499*",
    text: "Enhance your business operations with our business internet solutions providing 40 Mbps speed at just ₹ 499*. Get unlimited data, perfect for your business operations.",
    subscription: [
      {
        icon: ImageIcons.domainHeroIcon,
        title: "Domain",
        iconAlt: "Domain"
      },
      {
        icon: ImageIcons.hostingHeroIcon,
        title: "Hosting",
        iconAlt: "Hosting"
      },
      {
        icon: ImageIcons.cloudCamHeroIcon,
        title: "Cloud Surveillance",
        iconAlt: "Cloud Surveillance"
      },
    ],
    heroImg: ImageIcons.businessInternetBanner,
    heroAlt: "Business internet",
    handle: '/pricing/business-internet',
  },
  {
    entertainmentIcon: ImageIcons.intertainment,
    entertainmentAlt: "Inter Tainment",
    title: "Our Exclusive offers",
    subTitle: "Pay for 6 months toget one month FREE and pay for 12 months to get 3 months FREE!!",
    text: "Enjoy our exclusive offers where you just have to pay for 6 months and will get to enjoy connectivity for 7 months or pay for 12 months and get 2 months internet free. Stay connected with our unbeatable offers",
    subscription: [
      {
        icon: ImageIcons.wifiHeroIcon,
        title: "WIFI",
        iconAlt: "WIFI"
      },
      {
        icon: ImageIcons.ottHeroIcon,
        title: "OTT",
        iconAlt: "OTT"
      },
      {
        icon: ImageIcons.iptvHeroIcon,
        title: "IPTV",
        iconAlt: "IPTV"
      },
    ],
    heroImg: ImageIcons.exclusiveOffersBanner,
    heroAlt: "Our Exclusive offers",
    handle: '/pricing/home-internet',
  },
  {
    entertainmentIcon: ImageIcons.intertainment,
    entertainmentAlt: "Intertainment",
    title: "All Your Internet Needs in One App",
    text: "Simplify your internet experience with our user-friendly app, where you can manage your account,  track billing and payments and enjoy 24/7 customer support- everything at one place.",
    subscription: [
      {
        icon: ImageIcons.manageAccountHeroIcon,
        title: "Manage your account",
        iconAlt: "Manage your account"
      },
      {
        icon: ImageIcons.billingPaymentHeroIcon,
        title: "Billing and payment",
        iconAlt: "Billing and payment"
      },
      {
        icon: ImageIcons.customerSupportHeroIcon,
        title: "Customer Support",
        iconAlt: "Customer Support"
      },
    ],
    heroImg: ImageIcons.myinternetAppBanner,
    heroAlt: "Internet Needs in One App",
    handle: 'https://play.google.com/store/apps/details?id=app.customerportal.digitax&pcampaignid=web_share',
  },
]
export default Hero